import { render, staticRenderFns } from "./DetoxFileInfo.vue?vue&type=template&id=22eaee0c&"
import script from "./DetoxFileInfo.vue?vue&type=script&lang=ts&"
export * from "./DetoxFileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports